import type { PlaceIdentity, PlaceRequest, PlaceScene } from './score';
export interface PlaceContext extends PlaceIdentity {
    /** Renderer daylight at the player, 0..1. */
    daylight: number;
    settlement: {
        tier: number;
        dist: number;
        radius: number;
    } | null;
}
export const requestKey = (r: PlaceRequest): string => JSON.stringify([r.seed, r.biome, r.scene, r.night]);
/** Footprint hysteresis and a short dwell prevent music changing at every border step. */
export class PlaceContextSelector {
    private current: PlaceRequest | null = null;
    private candidate: PlaceRequest | null = null;
    private since = 0;
    update(context: PlaceContext | null, now: number): PlaceRequest | null {
        if (!context) {
            this.current = null;
            this.candidate = null;
            return null;
        }
        const same = this.current?.seed === context.seed && this.current.biome === context.biome;
        const settlement = context.settlement;
        const inside = settlement && settlement.dist <= settlement.radius + (same && this.current!.scene !== 'exploration' ? 35 : 0);
        const scene: PlaceScene = inside && settlement.tier >= 1 ? settlement.tier >= 4 ? 'large-city' : 'small-city' : 'exploration';
        const night = same ? this.current!.night ? context.daylight < .32 : context.daylight < .12 : context.daylight < .20;
        const next: PlaceRequest = { seed: context.seed, biome: context.biome, scene, night };
        if (!same) {
            this.current = next;
            this.candidate = null;
            return next;
        }
        if (requestKey(next) === requestKey(this.current!)) {
            this.candidate = null;
            return this.current;
        }
        if (!this.candidate || requestKey(next) !== requestKey(this.candidate)) {
            this.candidate = next;
            this.since = now;
        }
        if (now - this.since >= 3) {
            this.current = next;
            this.candidate = null;
        }
        return this.current;
    }
}
